import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Product } from '@common/product';
import { GalaxyCardComponent } from '@app/components/ui/galaxy-card/galaxy-card.component';
import { GalaxyButtonDirective } from '@app/directives/galaxy-button.directive';
import { GalaxyRippleDirective } from '@app/directives/galaxy-ripple.directive';
import { GalaxySkeletonComponent } from '@app/components/ui/galaxy-skeleton/galaxy-skeleton.component';
import { AnimateStaggerDirective } from '@app/directives/animate-stagger.directive';

@Component({
  selector: 'app-featured-products',
  imports: [
    CommonModule,
    RouterModule,
    DecimalPipe,
    GalaxyCardComponent,
    GalaxyButtonDirective,
    GalaxyRippleDirective,
    GalaxySkeletonComponent,
    AnimateStaggerDirective,
  ],
  templateUrl: './featured-products.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./featured-products.component.css'],
})
export class FeaturedProductsComponent {
  @Input() products: Product[] | null = [];
  @Input() isLoading: boolean | null = false;

  trackByProductId(index: number, product: Product): number {
    return product.id;
  }
}
